import React from 'react'

import { Button, Form, Grid, Header } from 'semantic-ui-react'

import { PROJECT_TYPE_OPTIONS, ProjectType } from '../../config/projectTypes'

const ProjectWorkflowSelector = ({ value, onChange }: IProps) => (
  <Form.Field>
    <label>Submission workflow</label>
    <p style={{ color: '#6b7280', marginTop: '0.35rem' }}>
      Choose how contributors will provide their video content. You can configure detailed limits and fields after
      creating the project.
    </p>
    <Grid columns={2} stackable role="radiogroup" aria-label="Submission workflow">
      {PROJECT_TYPE_OPTIONS.map((option) => {
        const selected = value === option.value
        const isComingSoon = option.value === 'video_compliance'

        return (
          <Grid.Column key={option.value}>
            <Button
              type="button"
              basic={!selected}
              primary={selected}
              fluid
              role="radio"
              aria-checked={selected}
              aria-disabled={isComingSoon}
              disabled={isComingSoon}
              onClick={() => onChange(option.value)}
              style={{
                height: '100%',
                minHeight: '112px',
                padding: '1rem',
                textAlign: 'left',
                whiteSpace: 'normal',
              }}
            >
              <Header as="h4" inverted={selected} style={{ marginBottom: '0.35rem' }}>
                {option.text}
                {isComingSoon && <small style={{ display: 'block' }}>Coming soon</small>}
                <Header.Subheader style={{ color: selected ? '#fff' : undefined, fontWeight: 700 }}>
                  {option.workflowName}
                </Header.Subheader>
              </Header>
              <span>{option.description}</span>
            </Button>
          </Grid.Column>
        )
      })}
    </Grid>
  </Form.Field>
)

interface IProps {
  value: ProjectType
  onChange: (projectType: ProjectType) => void
}

export default ProjectWorkflowSelector
